if (!customElements.get('banner-slider-component')) {
  customElements.define(
    'banner-slider-component',
    class BannerSliderComponent extends HTMLElement {
      constructor() {
        super();

        this.sliderControls = this.querySelector('.swiper-controls');
        this.sliderInstance = false;
        this.sectionId = this.dataset.sectionId;

        const slideCount = this.querySelectorAll('.swiper-slide').length;
        if (slideCount <= 1) return;

        this.initSlider();
      }

        initSlider() {
        const additionModules = [];

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          on: {
            init: this.handleAfterInit.bind(this)
          }
        };

        if (this.dataset.autoplay === 'true') {
          additionModules.push(FoxTheme.Swiper.Autoplay);
          this.sliderOptions.autoplay = {
            delay: parseInt(this.dataset.autoplayDelay, 10) || 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        if (this.dataset.autoplay === 'true') {
          this.sliderOptions.autoplay = {
            delay: parseInt(this.dataset.autoplayDelay, 10) || 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        if (this.sliderControls) {
          this.sliderOptions.navigation = {
            nextEl: this.sliderControls.querySelector('.swiper-button-next'),
            prevEl: this.sliderControls.querySelector('.swiper-button-prev')
          };
          this.sliderOptions.pagination = {
            el: this.sliderControls.querySelector('.swiper-pagination'),
            clickable: true
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, additionModules);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('realIndexChange', this.handleSlideChange.bind(this));

        if (this.sliderInstance) {
          const activeSlide = this.sliderInstance.slider.slides[this.sliderInstance.slider.activeIndex];
          this.refreshMotion(activeSlide);
        }
      }

      handleAfterInit() {
        if (this.sliderControls) {
          const activeBullet = this.sliderControls.querySelector('.swiper-pagination-bullet-active');
          if (activeBullet) {
            activeBullet.classList.remove('swiper-pagination-bullet-active');
            activeBullet.offsetHeight; // Trigger reflow.
            activeBullet.classList.add('swiper-pagination-bullet-active');
          }
        }
      }

      handleSlideChange(swiper) {
        const { slides, activeIndex } = swiper;
        this.refreshMotion(slides[activeIndex]);
      }

      refreshMotion(slideEl) {
        if (!slideEl || !window.FoxTheme?.a11y?.shouldAnimate?.()) return;

        const motionEls = slideEl.querySelectorAll('motion-element');
        motionEls.forEach((motionEl) => {
          setTimeout(() => {
            motionEl && motionEl.refreshAnimation && motionEl.refreshAnimation();
          });
        });
      }
    }
  );
}